import { createUseStyles } from 'react-jss';
import { theme } from '../../../theme';

export const styles = createUseStyles({
    toggleContainer: ({ rtl, noAccess, isLong }) => ({
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'flex-start',
        position: 'relative',
        overflow: isLong ? 'auto' : 'unset',
        maxWidth: isLong ? '94vw' : 'unset',
        paddingInlineEnd: isLong ? '5px' : '0',
        // overflow: 'auto',
        // paddingInlineEnd: '5px',
        '& input': {
            opacity: 0,
            position: 'absolute',
            pointerEvents: 'none'
        },
        '& input + label': {
            margin: 0,
            minHeight: '34px',
            padding: '0 0.5rem',
            boxSizing: 'border-box',
            position: 'relative',
            borderTop: '1px solid #bbb',
            borderBottom: '1px solid #bbb',
            backgroundColor: '#FFF',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            transition: 'background-color .15s ease-out',
            width: '100%'
        },
        '& label:first-of-type': {
            borderRadius: rtl ? '0 4px 4px 0' : '4px 0 0 4px',
            borderLeft: rtl ? 'unset' : '1px solid #bbb',
            borderRight: rtl ? '1px solid #bbb' : 'unset'
        },
        '& label:last-of-type': {
            borderRadius: rtl ? '4px 0 0 4px' : '0 4px 4px 0',
            borderRight: rtl ? 'unset' : '1px solid #bbb',
            borderLeft: rtl ? '1px solid #bbb' : 'unset'
        },
        '& label:nth-child(even)': {
            borderLeft: '1px solid #bbb'
        },
        '& input:hover + label': { cursor: 'pointer' },
        '& input:focus + label': {
            outline: '5px auto -webkit-focus-ring-color',
            outlineColor: 'rgb(0 123 255 / 25%)'
        },
        '& input:checked + label': {
            backgroundColor: noAccess ? theme.grayColor3 : theme.primaryColor,
            color: '#fff',
            border: noAccess ? `1px solid ${theme.grayColor3}` : `1px solid ${theme.primaryColor}`,
            fontFamily: 'inherit',
            zIndex: 1
        },
        '& input:disabled + label': {
            opacity: noAccess ? 0.5 : 1,
            cursor: noAccess ? 'not-allowed !important' : 'pointer'
        }
    }),
    '@media (max-width: 768px)': {
        toggleContainer: {
            maxWidth: '90vw !important'
        }
    },
    '@media (max-width: 450px)': {
        toggleContainer: {
            maxWidth: '87vw !important'
        }
    },
    '@media (max-width: 321px)': {
        toggleContainer: {
            maxWidth: '85vw !important'
        }
    }
});
